export default "__VITE_ASSET__B8_Q6_Eu__"